import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import { ComboboxField } from '../../../Components/formElements/ComboboxField';
import Layout from "../../../../Layout/Layout";
import OrdersColumnChart from "./../../Charts/OrdersColumnChart";
import DonutChart from "./../../Charts/DonutChartCustomerV2";
import PieChart from "./../../Charts/PieChartCustomerV2";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector } from "react-redux"; //useDispatch
import customerItemService from "../../../../services/customer_appCommonService";
import LoaderSmall from "../../../../Components/LoaderSmall";

import {
  // formatNumberShort,
  formatToTwoDigits,
  getCurrentDate,
} from "../../../../common/Validations";
import DatePickerComponent from "./../../Charts/FilterComponent/DatePickerComponent";
// import SupplierConstants from "../../common/SupplierConstants";
import CustomerConstants from "../../../../common/CustomerConstants";
import HorizontalBarChart from "../../Charts/HorizontalBarChart";
import FastMovingMaterials from "./FastMovingMaterials";
import { PERIODS, rangeFor } from "./dashboardPeriod";
import { ChartPanel, DashboardSection } from "./DashboardSection";
import "./CustomerV2Dashboard.css";
import LogisticsConstants from "../../../../common/LogisticsConstants";
// import TreeMapChartDashboardChart from "../../Charts/TreeMapChartDashboardChart";

const CustomerV2Dashboard = () => {
  localStorage.setItem("menu", "Dashboard");
  localStorage.setItem("submenu", "-");
  const navigate = useNavigate();

  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  const openSummaryCard = (event, page) => {
    if (event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    navigateToMainPage(page);
  };

  const navigateToMainPage = (page) => {
    if (page === "totalOrderCount") {
      navigate(CustomerConstants.CUSTOMER_V2_ORDER_BOOKING_LIST_LINE_ITEM);
    } else if (page === "loadingAdvice") {
      navigate(CustomerConstants.CUSTOMER_V2_LOADING_ADVICE_LIST);
    } else if (page === "totalInvoiceCount") {
      navigate(CustomerConstants.CUSTOMER_V2_INVOICE_LIST);
    } else if (page === "totalUserCount") {
      navigate(CustomerConstants.CUSTOMER_V2_CUSTOMER_MASTER_LIST);
    } else if (page === "totalFuelCount") {
      navigate(LogisticsConstants.LOGISTICS_FUEL_ENTRY_LIST);
    } else if (page === "totalTripDeilverd") {
      navigate(LogisticsConstants.LOGISTICS_TRANSPORT_REQUEST_LIST_ACK);
    } else if (page === "totalTripInTransit") {
      navigate(LogisticsConstants.LOGISTICS_TRANSPORT_REQUEST_LIST_INT);
    }
  };

  const [filterShow, setFilterShow] = useState(false);

  const [totalUserCount, setTotalUserCount] = useState("");
  const [totalUserCountStatus, setTotalUserCountStatus] = useState(false);

  const [totalLoadingAdviceCount, setTotalLoadingAdviceCount] = useState("");
  const [totalLoadingAdviceCountStatus, setTotalLoadingAdviceCountStatus] =
    useState(false);

  const [totalInvoiceCount, setTotalInvoiceCount] = useState("");
  const [totalInvoiceCountStatus, setTotalInvoiceCountStatus] = useState(false);

  const [totalfuelCount, setTotalfuelCount] = useState("");
  const [totalfuelCountStatus, setTotalfuelCountStatus] = useState(false);

  const [totalTripCount, setTotalTripCount] = useState("");
  const [totalTripCountStatus, setTotalTripCountStatus] = useState(false);
  const [totalTripIntCount, setTotalTripIntCount] = useState("");
  const [totalTripIntCountStatus, setTotalTripIntCountStatus] = useState(false);
  const [totalOrderCount, setTotalOrderCount] = useState("");
  const [totalOrderCountStatus, setTotalOrderStatus] = useState(false);

  const [supplierStatusColChart, setSupplierStatusColChart] = useState("");
  const [loadingAdviceColChart, setLoadingAdviceColChart] = useState("");
  const [invoiceColChart, setInvoiceColChart] = useState("");
  const [hideItem, setHideItem] = useState(false);
  const [supplierStatusLoading, setSupplierStatusLoading] = useState(false);
  const [loadingAdviceLoading, setLoadingAdviceLoading] = useState(false);
  const [invoiceLoading, setInvoiceLoading] = useState(false);

  const [marketingTeamData, setMarketingTeamData] = useState(null);
  const [marketingTeamLoading, setMarketingTeamLoading] = useState(false);
  const [officerChartData, setOfficerChartData] = useState(null);
  const [officerChartLoading, setOfficerChartLoading] = useState(false);
  const [officers, setOfficers] = useState([]);
  const [orderStatuses, setOrderStatuses] = useState([]);
  const [salesOfficerCode, setSalesOfficerCode] = useState("");
  const [salesOrderStatus, setSalesOrderStatus] = useState("");
  const [lockedOfficer, setLockedOfficer] = useState("");
  const monthSpan = rangeFor("month");
  const [period, setPeriod] = useState("month");
  const [fromDate, setFromDate] = useState(monthSpan.fromDate);
  const [toDate, setToDate] = useState(monthSpan.toDate);
  const [chartQuery, setChartQuery] = useState({
    action: "Custom",
    fromDate: monthSpan.fromDate,
    toDate: monthSpan.toDate,
  });

  const loadMarketingTeamChart = async (filterData) => {
    setMarketingTeamLoading(true);

    try {
      let queryName = "";
      if (filterData.action === "Yearly") {
        queryName = "Yearly_Pie_Order_Chart";
      } else if (filterData.action === "Monthly") {
        queryName = "Monthly_Pie_Order_Chart";
      } else if (filterData.action === "Custom") {
        queryName = "Custom_Pie_Order_Chart";
      }

      const payload = {
        module: "order",
        action: filterData.action,
        chartType: "doughnut",
        queryName,
        year: filterData.year,
        month: filterData.month,
        fromDate: filterData.fromDate,
        toDate: filterData.toDate,
        salesOfficerCode: filterData.salesOfficerCode || "",
        salesOrderStatus: filterData.salesOrderStatus || "",
        timeZone: "Asia/Calcutta",
      };

      //Call dashboard API
      const response = await customerItemService.dashboard(payload);

      if (response?.status !== 200 || !response?.data) {
        throw new Error(response?.message || "Failed to load marketing chart");
      }

      const { categories, series, percentage, getQueryResponse } =
        response.data;

      const chartData = {
        categories,
        series,
        percentage,
        rows: getQueryResponse,
      };

      setMarketingTeamData(chartData);
    } catch (error) {
      console.error("Error loading Marketing Team chart:", error);
      toast.error("Error loading Marketing Team chart");
    } finally {
      setMarketingTeamLoading(false);
    }
  };

  const loadOfficerChart = async (filterData) => {
    setOfficerChartLoading(true);
    try {
      const response = await customerItemService.dashboard({
        module: "order",
        action: filterData.action,
        chartType: "pie",
        queryName: "Custom_Pie_Sales_Order_Chart",
        year: filterData.year,
        month: filterData.month,
        fromDate: filterData.fromDate,
        toDate: filterData.toDate,
        salesOfficerCode: filterData.salesOfficerCode || "",
        salesOrderStatus: filterData.salesOrderStatus || "",
        timeZone: "Asia/Calcutta",
      });
      if (response?.status !== 200 || !response?.data) {
        throw new Error(
          response?.message || "Failed to load sales officer chart",
        );
      }
      const { categories, series, percentage, getQueryResponse } =
        response.data;
      setOfficerChartData({
        categories,
        series,
        percentage,
        rows: getQueryResponse,
      });
    } catch (error) {
      console.error("Error loading sales officer chart:", error);
      toast.error("Error loading sales officer chart");
    } finally {
      setOfficerChartLoading(false);
    }
  };

  const hasChartData = (data) => {
    if (!data) return false;
    if (!Array.isArray(data.series)) return false;
    return data.series.some((v) => v > 0);
  };

  // loadOrderCount
  const loadOrderCount = async () => {
    setTotalOrderStatus(true);
    let obj = {
      queryName: "totalOrderBookingCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalOrderCount(item.data);

        // loadOrderCompletedCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalOrderStatus(false);
  };

  // loadOrderCompletedCount
  // const loadOrderCompletedCount = async (totalOrderCountVal) => {
  //   setOrderCompletedStatus(true);
  //   let obj = {
  //     queryName: "totalOrderCompletedCount",
  //   };

  //   await customerItemService.ChartCountCard(obj).then((item) => {
  //     // console.log(">> Details res!", item);
  //     if (item?.status === 200) {
  //       setOrderCompletedCount(item.data);
  //       let orderComplete = item.data;
  //       setPendingCount(totalOrderCountVal - orderComplete);
  //     } else {
  //       toast.error(item?.message || "Please try again for Total PO Count", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });
  //   setOrderCompletedStatus(false);
  // };

  // loadConfirmedDispatchCount
  // const loadConfirmedDispatchCount = async () => {
  //   setConfirmedDispatchStatus(true);
  //   let obj = {
  //     queryName: "totalOrderBookingCount",
  //   };

  //   await customerItemService.ChartCountCard(obj).then((item) => {
  //     // console.log(">> Details res!", item);
  //     if (item?.status === 200) {
  //       setConfirmedDispatchCount(item.data);
  //     } else {
  //       toast.error(item?.message || "Please try again for Total PO Count", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });
  //   setConfirmedDispatchStatus(false);
  // };

  // loadCustomerCount
  const loadCustomerCount = async () => {
    setTotalUserCountStatus(true);
    let obj = {
      queryName: "totalCustomerCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalUserCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalUserCountStatus(false);
  };

  // loadInvoice
  // const loadInvoiceCount = async () => {
  //   setTotalInvoiceCountStatus(true);
  //   let obj = {
  //     queryName: "Company_And_Customer_Ledger",
  //     rowFilter: {
  //       $and: [
  //         {
  //           transactionType: "INV",
  //         },
  //       ],
  //     },
  //     page: 1,
  //     per_page: 10,
  //   };

  //   await customerItemService.generateCustomerQuery(obj).then((item) => {
  //     // console.log(">> Details res!", item);
  //     if (item?.status === 200) {
  //       setTotalInvoiceCount(item?.total ?? 0);
  //     } else {
  //       toast.error(item?.message || "Please try again for Total User Count", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });

  //   // let obj = {
  //   //   queryName: "totalInvoiceCount",
  //   // };

  //   // await customerItemService.ChartCountCard(obj).then((item) => {
  //   //   // console.log(">> Details res!", item);
  //   //   if (item?.status === 200) {
  //   //     setTotalInvoiceCount(item.data);
  //   //   } else {
  //   //     toast.error(item?.message || "Please try again for Total User Count", {
  //   //       duration: 4000,
  //   //       position: "top-right",
  //   //     });
  //   //   }
  //   // });
  //   setTotalInvoiceCountStatus(false);
  // };

  const loadInvoiceCount = async () => {
    try {
      setTotalInvoiceCountStatus(true);

      const obj = {
        queryName: "getCustomerInvoiceList",
        page: 1,
        per_page: 10,
      };

      const item = await customerItemService.generateCustomerQuery(obj);

      if (item?.status === 200) {
        setTotalInvoiceCount(item?.total ?? 0);
      } else {
        toast.error(
          item?.message || "Please try again for Total Invoice Count",
          {
            duration: 4000,
            position: "top-right",
          },
        );
      }
    } catch (error) {
      console.error("Invoice Count Error:", error);
      setTotalInvoiceCount(0);
    } finally {
      setTotalInvoiceCountStatus(false);
    }
  };

  useEffect(() => {
    loadInvoiceCount();
    loadingAdviceCount();
  }, []);
  // loadFuel
  const loadFuelCount = async () => {
    setTotalfuelCountStatus(true);
    let obj = {
      queryName: "totalLogisticsFuelCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalfuelCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalfuelCountStatus(false);
  };

  // loadtripDeliverd
  const loadTripCount = async () => {
    setTotalTripCountStatus(true);
    let obj = {
      queryName: "totalLogisticsTripCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalTripCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalTripCountStatus(false);
  };

  // loadFuel
  const loadTripIntCount = async () => {
    setTotalTripIntCountStatus(true);
    let obj = {
      queryName: "totalLogisticsInTripCount",
    };

    await customerItemService.ChartCountCard(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalTripIntCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalTripIntCountStatus(false);
  };

  const loadingAdviceCount = async () => {
    try {
      setTotalLoadingAdviceCountStatus(true);

      const obj = {
        queryName: "getLoadingAdviceList",
      };

      const item = await customerItemService.generateCustomerQuery(obj);

      if (item?.status === 200) {
        setTotalLoadingAdviceCount(item?.total || 0);
      } else {
        toast.error(
          item?.message || "Please try again for Total Loading Advice Count",
          {
            duration: 4000,
            position: "top-right",
          },
        );
      }
    } catch (error) {
      console.error("Loading Advice Count Error:", error);
      setTotalLoadingAdviceCount(0);
    } finally {
      setTotalLoadingAdviceCountStatus(false);
    }
  };

  const suppliersChart = async (filterData) => {
    setSupplierStatusLoading(true);
    filterData.module = "order";
    filterData.chartType = "bar";

    try {
      const item = await customerItemService.dashboard(filterData);
      if (item?.status === 200) {
        item.data.module = "order";
        setSupplierStatusColChart(item.data);
      } else {
        toast.error(item?.message || "Please try again for Orders");
      }
    } catch (error) {
      toast.error("Error fetching Orders chart data");
    }
    setSupplierStatusLoading(false);
  };

  const loadingAdviceChart = async (filterData) => {
    setLoadingAdviceLoading(true);
    filterData.module = "loadingAdvice";
    filterData.chartType = "bar";

    try {
      const item = await customerItemService.dashboard(filterData);
      if (item?.status === 200) {
        item.data.module = "loadingAdvice";
        setLoadingAdviceColChart(item.data);
      } else {
        toast.error(item?.message || "Please try again for Loading Advice");
      }
    } catch (error) {
      toast.error("Error fetching Loading Advice chart data");
    }
    setLoadingAdviceLoading(false);
  };

  const InvoiceChart = async (filterData) => {
    setInvoiceLoading(true);
    filterData.module = "invoice";
    filterData.chartType = "bar";

    const item = await customerItemService.dashboard(filterData);
    if (item?.status === 200) {
      setInvoiceColChart(item.data); // ✅ FIXED from serInvoiceColChart
    } else {
      toast.error(item?.message || "Please try again for Invoice Chart");
    }
    setInvoiceLoading(false);
  };

  const runCharts = async (
    filter,
    officer = salesOfficerCode,
    status = salesOrderStatus,
  ) => {
    const next = {
      ...filter,
      salesOfficerCode: officer,
      salesOrderStatus: status,
    };
    setChartQuery(filter);
    await suppliersChart(next);
    await loadingAdviceChart(next);
    await InvoiceChart(next);
    await loadOfficerChart(next);
    await loadMarketingTeamChart(next);
  };

  const applyChartPeriod = (next, from = fromDate, to = toDate) => {
    setPeriod(next);
    const span =
      next === "custom"
        ? { fromDate: from, toDate: to || from }
        : rangeFor(next);
    setFromDate(span.fromDate);
    setToDate(span.toDate);
    runCharts({
      action: "Custom",
      fromDate: span.fromDate,
      toDate: span.toDate,
    });
  };

  // On Filtered Data
  const handleFilterData = async (filter) => {
    await runCharts(filter);
  };

  useEffect(() => {
    let defaultFilter = {
      action: "Custom",
      fromDate: monthSpan.fromDate,
      toDate: monthSpan.toDate,
    };

    loadOrderCount();
    // loadOrderCompletedCount();
    // loadPostDispatchCount();
    // loadConfirmedDispatchCount();
    loadTripIntCount();
    loadTripCount();
    loadFuelCount();
    loadCustomerCount();
    loadInvoiceCount();
    loadingAdviceCount();

    runCharts(defaultFilter);
    customerItemService.dashboardFilterOptions({}).then((result) => {
      if (result?.status !== 200 || !result.data) return;
      setOfficers(result.data.officers || []);
      setOrderStatuses(result.data.statuses || []);
      if (result.data.lockedOfficer) {
        setLockedOfficer(result.data.lockedOfficer);
        setSalesOfficerCode(result.data.lockedOfficer);
      }
    });
    // poChart(defaultFilter);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const userRole = userData?.roles?.[0]?.roleId || null;

    if (userRole === "CUSTOMER") {
      setHideItem(true);
    } else {
      setHideItem(false);
    }
    // console.log(">> userRole", userRole);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  //role selection
  const [userRoleData, setUserRoleData] = useState(false);
  const [isLogisticsRole, setIsLogisticsRole] = useState(false);

  useEffect(() => {
    const roles = userData?.roles || [];

    const isSalesOfficer = roles.some(
      (role) => role.roleId === "SALES-OFFICER",
    );

    const isLogistics = roles.some((role) =>
      ["LGADMIN", "LGSTAFF", "LOGISTICS-ADMIN", "LOGISTICS-STAFF"].includes(
        role.roleId,
      ),
    );

    setUserRoleData(isSalesOfficer);
    setIsLogisticsRole(isLogistics);
  }, [userData]);

  const customerCount = Array.isArray(marketingTeamData?.categories)
    ? marketingTeamData.categories.length
    : 0;
  const pairHeight = customerCount
    ? Math.min(640, Math.max(480, customerCount * 44 + 80))
    : 480;

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner timesheet">
            <Row>
              <Col xs={10} md={10}>
                <h2 className="mainTitle">
                  Dashboard -
                  <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                    {getCurrentDate()}
                  </span>
                </h2>
                <p className="subText my-0">Dashboard detailed page</p>
              </Col>
              <Col xs={2} md={2}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i className="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />

            <section className="section sv-dashboard">
              <DashboardSection
                title="Summary"
                hint="Counts update with the live records. Collapse this group to hide the cards."
              >
                <div className="row dash-summary-row">
                  {!isLogisticsRole && (
                    <div className="col-lg-3 commTopButtonRightLeftPadding">
                      <div
                        className="card info-card sales-card"
                        role="link"
                        tabIndex={0}
                        onClick={() => navigateToMainPage("totalOrderCount")}
                        onKeyDown={(event) =>
                          openSummaryCard(event, "totalOrderCount")
                        }
                      >
                        <div className="card-body">
                          <h5 className="card-title">
                            Orders
                            {/* <span>| Today</span> */}
                          </h5>

                          <div className="d-flex align-items-center">
                            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                              <i className="bi bi-boxes"></i>
                            </div>
                            <div className="ps-3">
                              <LoaderSmall isLoading={totalOrderCountStatus} />
                              <h6>
                                {!totalOrderCountStatus
                                  ? formatToTwoDigits(totalOrderCount || 0)
                                  : ""}
                              </h6>
                              {/* <span className="text-success small pt-1 fw-bold">
                            12%
                          </span>{" "} */}
                              <span className="text-muted small pt-2 ps-1">
                                Total Count
                              </span>
                              <span className="text-muted small pt-2 ps-1">
                                <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {!hideItem && !isLogisticsRole && (
                    <div className="col-lg-3 commTopButtonRightLeftPadding">
                      <div
                        className="card info-card customers-card"
                        role="link"
                        tabIndex={0}
                        onClick={() => navigateToMainPage("loadingAdvice")}
                        onKeyDown={(event) =>
                          openSummaryCard(event, "loadingAdvice")
                        }
                      >
                        <div className="card-body">
                          <h5 className="card-title">Loading</h5>

                          <div className="d-flex align-items-center">
                            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                              <i className="bi bi-truck"></i>{" "}
                            </div>
                            <div className="ps-3">
                              <LoaderSmall
                                isLoading={totalLoadingAdviceCountStatus}
                              />
                              <h6>
                                {!totalLoadingAdviceCountStatus
                                  ? formatToTwoDigits(
                                      totalLoadingAdviceCount || 0,
                                    )
                                  : ""}
                              </h6>

                              <span className="text-muted small pt-2 ps-1">
                                Total Count
                              </span>
                              <span className="text-muted small pt-2 ps-1">
                                <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {!hideItem && !isLogisticsRole && (
                    <div className="col-lg-3 commTopButtonRightLeftPadding">
                      <div
                        className="card info-card revenue-card"
                        role="link"
                        tabIndex={0}
                        onClick={() => navigateToMainPage("totalInvoiceCount")}
                        onKeyDown={(event) =>
                          openSummaryCard(event, "totalInvoiceCount")
                        }
                      >
                        <div className="card-body">
                          <h5 className="card-title">Invoice</h5>

                          <div className="d-flex align-items-center">
                            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                              <i className="bi bi-file-text"></i>
                            </div>
                            <div className="ps-3">
                              <LoaderSmall
                                isLoading={totalInvoiceCountStatus}
                              />
                              <h6>
                                {!totalInvoiceCountStatus
                                  ? formatToTwoDigits(totalInvoiceCount || 0)
                                  : ""}
                              </h6>
                              {/* <span className="text-success small pt-1 fw-bold">
                          12%
                        </span>{" "} */}
                              <span className="text-muted small pt-2 ps-1">
                                Total Count
                              </span>
                              <span className="text-muted small pt-2 ps-1">
                                <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {!hideItem && !isLogisticsRole && (
                    <div className="col-lg-3 commTopButtonRightLeftPadding">
                      <div
                        className="card info-card customers-card"
                        role="link"
                        tabIndex={0}
                        onClick={() => navigateToMainPage("totalUserCount")}
                        onKeyDown={(event) =>
                          openSummaryCard(event, "totalUserCount")
                        }
                      >
                        <div className="card-body">
                          <h5 className="card-title">
                            Customers
                            {/* <span>| This Year</span> */}
                          </h5>

                          <div className="d-flex align-items-center">
                            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                              <i className="bi bi-people"></i>
                            </div>
                            <div className="ps-3">
                              <LoaderSmall isLoading={totalUserCountStatus} />
                              <h6>
                                {!totalUserCountStatus
                                  ? formatToTwoDigits(totalUserCount || 0)
                                  : ""}
                              </h6>
                              {/* <span className="text-success small pt-1 fw-bold">
                          12%
                        </span>{" "} */}
                              <span className="text-muted small pt-2 ps-1">
                                Total Count
                              </span>
                              <span className="text-muted small pt-2 ps-1">
                                <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* fuel count */}
                  {!userRoleData && !hideItem && (
                    <div className="col-lg-3 commTopButtonRightLeftPadding">
                      <div
                        className="card info-card revenue-card"
                        role="link"
                        tabIndex={0}
                        onClick={() => navigateToMainPage("totalFuelCount")}
                        onKeyDown={(event) =>
                          openSummaryCard(event, "totalFuelCount")
                        }
                      >
                        <div className="card-body">
                          <h5 className="card-title">Fuel</h5>

                          <div className="d-flex align-items-center">
                            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                              <i className="bi bi-fuel-pump"></i>
                            </div>
                            <div className="ps-3">
                              <LoaderSmall isLoading={totalfuelCountStatus} />
                              <h6>
                                {!totalfuelCountStatus
                                  ? formatToTwoDigits(totalfuelCount || 0)
                                  : ""}
                              </h6>
                              {/* <span className="text-success small pt-1 fw-bold">
                          12%
                        </span>{" "} */}
                              <span className="text-muted small pt-2 ps-1">
                                Total Count
                              </span>
                              <span className="text-muted small pt-2 ps-1">
                                <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Trip count */}
                  {!userRoleData && !hideItem && (
                    <div className="col-lg-3 commTopButtonRightLeftPadding">
                      <div
                        className="card info-card revenue-card"
                        role="link"
                        tabIndex={0}
                        onClick={() => navigateToMainPage("totalTripDeilverd")}
                        onKeyDown={(event) =>
                          openSummaryCard(event, "totalTripDeilverd")
                        }
                      >
                        <div className="card-body">
                          <h5 className="card-title">Trip (Delivered)</h5>

                          <div className="d-flex align-items-center">
                            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                              <i className="bi bi-truck"></i>{" "}
                            </div>
                            <div className="ps-3">
                              <LoaderSmall isLoading={totalTripCountStatus} />
                              <h6>
                                {!totalTripCountStatus
                                  ? formatToTwoDigits(totalTripCount || 0)
                                  : ""}
                              </h6>
                              {/* <span className="text-success small pt-1 fw-bold">
                          12%
                        </span>{" "} */}
                              <span className="text-muted small pt-2 ps-1">
                                Total Count
                              </span>
                              <span className="text-muted small pt-2 ps-1">
                                <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {!userRoleData && !hideItem && (
                    <div className="col-lg-3 commTopButtonRightLeftPadding">
                      <div
                        className="card info-card customers-card"
                        role="link"
                        tabIndex={0}
                        onClick={() => navigateToMainPage("totalTripInTransit")}
                        onKeyDown={(event) =>
                          openSummaryCard(event, "totalTripInTransit")
                        }
                      >
                        <div className="card-body">
                          <h5 className="card-title">Trip (In Transit)</h5>

                          <div className="d-flex align-items-center">
                            <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                              <i className="bi bi-truck-front"></i>{" "}
                            </div>
                            <div className="ps-3">
                              <LoaderSmall
                                isLoading={totalTripIntCountStatus}
                              />
                              <h6>
                                {!totalTripIntCountStatus
                                  ? formatToTwoDigits(totalTripIntCount || 0)
                                  : ""}
                              </h6>
                              {/* <span className="text-success small pt-1 fw-bold">
                          12%
                        </span>{" "} */}
                              <span className="text-muted small pt-2 ps-1">
                                Total Count
                              </span>
                              <span className="text-muted small pt-2 ps-1">
                                <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </DashboardSection>
              {filterShow && (
                <DatePickerComponent
                  getfiltereddata={handleFilterData}
                  cancelAction={() => setFilterShow(!filterShow)}
                />
              )}
              {!isLogisticsRole && (
                <div className="row">
                  <div className="col-lg-12 commTopButtonRightLeftPadding">
                    <DashboardSection
                      title="Chart filters"
                      hint="Today, this week, this month, quarter, year, or a custom range."
                    >
                      <div className="card dash-filter-card">
                        <div className="card-body">
                          <div className="dash-filter-grid">
                            <div className="dash-field">
                              <label className="form-label">Period</label>
                              <select
                                className="form-select"
                                value={period}
                                onChange={(event) =>
                                  applyChartPeriod(event.target.value)
                                }
                              >
                                {PERIODS.map((item) => (
                                  <option key={item.id} value={item.id}>
                                    {item.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="dash-field">
                              <label className="form-label">From date</label>
                              <input
                                className="form-control"
                                type="date"
                                value={fromDate}
                                disabled={period !== "custom"}
                                onChange={(event) =>
                                  applyChartPeriod(
                                    "custom",
                                    event.target.value,
                                    toDate,
                                  )
                                }
                              />
                            </div>
                            <div className="dash-field">
                              <label className="form-label">To date</label>
                              <input
                                className="form-control"
                                type="date"
                                value={toDate}
                                disabled={period !== "custom"}
                                onChange={(event) =>
                                  applyChartPeriod(
                                    "custom",
                                    fromDate,
                                    event.target.value,
                                  )
                                }
                              />
                            </div>
                            <div className="dash-field">
                              <label className="form-label">
                                Sales Officer Code
                              </label>
                              <select
                                className="form-select"
                                value={lockedOfficer || salesOfficerCode}
                                disabled={Boolean(lockedOfficer)}
                                onChange={(event) => {
                                  const value = event.target.value;
                                  setSalesOfficerCode(value);
                                  runCharts(
                                    chartQuery,
                                    value,
                                    salesOrderStatus,
                                  );
                                }}
                              >
                                {!lockedOfficer && (
                                  <option value="">All officers</option>
                                )}
                                {officers.map((officer) => (
                                  <option
                                    key={officer.code}
                                    value={officer.code}
                                  >
                                    {officer.code}
                                    {officer.name ? ` - ${officer.name}` : ""}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="dash-field">
                              <label className="form-label">
                                Sales Order Status
                              </label>
                              <select
                                className="form-select"
                                value={salesOrderStatus}
                                onChange={(event) => {
                                  const value = event.target.value;
                                  setSalesOrderStatus(value);
                                  runCharts(
                                    chartQuery,
                                    lockedOfficer || salesOfficerCode,
                                    value,
                                  );
                                }}
                              >
                                <option value="">All statuses</option>
                                {orderStatuses.map((status) => (
                                  <option key={status} value={status}>
                                    {status}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </DashboardSection>
                  </div>
                  {/* Orders */}
                  <ChartPanel title="Orders">
                    <LoaderSmall isLoading={supplierStatusLoading} />
                    <h6>
                      {!supplierStatusLoading ? (
                        <OrdersColumnChart
                          key={`order-${salesOfficerCode}-${salesOrderStatus}-${chartQuery.action}-${chartQuery.month || ""}-${chartQuery.year || ""}-${chartQuery.fromDate || ""}`}
                          exportName="orders"
                          chartdata={supplierStatusColChart}
                        />
                      ) : (
                        ""
                      )}
                    </h6>
                  </ChartPanel>
                  {/* Loading Advice */}
                  <ChartPanel title="Loading">
                    <LoaderSmall isLoading={loadingAdviceLoading} />
                    <h6>
                      {!loadingAdviceLoading ? (
                        <OrdersColumnChart
                          key={`loading-${salesOfficerCode}-${salesOrderStatus}-${chartQuery.action}-${chartQuery.month || ""}-${chartQuery.year || ""}-${chartQuery.fromDate || ""}`}
                          exportName="loading"
                          chartdata={loadingAdviceColChart}
                        />
                      ) : (
                        ""
                      )}
                    </h6>
                  </ChartPanel>
                  {/* Invoice */}
                  <ChartPanel title="Invoice">
                    <LoaderSmall isLoading={invoiceLoading} />
                    <h6>
                      {!invoiceLoading ? (
                        <OrdersColumnChart
                          key={`invoice-${salesOfficerCode}-${salesOrderStatus}-${chartQuery.action}-${chartQuery.month || ""}-${chartQuery.year || ""}-${chartQuery.fromDate || ""}`}
                          exportName="invoice"
                          chartdata={invoiceColChart}
                        />
                      ) : (
                        ""
                      )}
                    </h6>
                  </ChartPanel>

                  <FastMovingMaterials
                    officers={officers}
                    statuses={orderStatuses}
                    lockedOfficer={lockedOfficer}
                  />
                  {/* PO */}
                  {/* <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Purchase Order</h5>
                      <LoaderSmall isLoading={poStatusColChartStatus} />
                      <h6>
                        {!poStatusColChartStatus ? (
                          <POColumnChart
                            key="po"
                            chartdata={poStatusColChart}
                          />
                        ) : (
                          ""
                        )}
                      </h6>
                    </div>
                  </div>
                </div> */}

                  {/* <div className="col-lg-6 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Procurement</h5>

                      <div id="lineChart"></div>
                      <LineChart />
                    </div>
                  </div>
                </div> */}

                  {/* <div className="col-lg-6 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Revenue</h5>

                      <div id="areaChart"></div>
                      <AreaChart />
                    </div>
                  </div>
                </div> */}

                  {/* <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Country</h5>

                      <div id="barChart"></div>
                      <BarChart />
                    </div>
                  </div>
                </div> */}

                  {/* <div className="col-lg-6 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Sales Team</h5>

                      <div id="pieChart"></div>
                      <PieChart />
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Marketing Team</h5>

                      <div id="donutChart"></div>
                      <DonutChart />
                    </div>
                  </div>
                </div> */}
                  {!hideItem && !userRoleData && !isLogisticsRole && (
                    <ChartPanel title="Sales Officer" className="col-lg-6">
                      <LoaderSmall isLoading={officerChartLoading} />
                      {!officerChartLoading ? (
                        hasChartData(officerChartData) ? (
                          <PieChart
                            chartdata={officerChartData}
                            tooltipSuffix="orders"
                            exportName="sales-officer-orders"
                            height={pairHeight}
                          />
                        ) : (
                          <p className="text-center text-muted py-5">
                            No sales officer orders available
                          </p>
                        )
                      ) : null}
                    </ChartPanel>
                  )}
                  {!hideItem && !userRoleData && !isLogisticsRole && (
                    <ChartPanel title="Sales" className="col-lg-6">
                      <LoaderSmall isLoading={marketingTeamLoading} />

                      {!marketingTeamLoading ? (
                        hasChartData(marketingTeamData) ? (
                          <DonutChart
                            chartdata={marketingTeamData}
                            valueLabel="Total Sales"
                            tooltipSuffix="orders"
                            exportName="sales-share"
                            height={pairHeight}
                          />
                        ) : (
                          <p className="text-center text-muted py-5">
                            No Sales available
                          </p>
                        )
                      ) : null}
                    </ChartPanel>
                  )}
                  {!hideItem && !userRoleData && !isLogisticsRole && (
                    <ChartPanel
                      title="Orders by Customer"
                      className="col-lg-12"
                    >
                      <LoaderSmall isLoading={marketingTeamLoading} />
                      {!marketingTeamLoading ? (
                        hasChartData(marketingTeamData) ? (
                          <HorizontalBarChart
                            chartdata={marketingTeamData}
                            height={pairHeight}
                            barColor="#008FFB"
                            xAxisTitle="Number of Orders"
                            tooltipUnit="orders"
                            decimalPoints={0}
                            exportName="orders-by-customer"
                          />
                        ) : (
                          <p className="text-center text-muted py-5">
                            No orders available
                          </p>
                        )
                      ) : null}
                    </ChartPanel>
                  )}
                  {/* <div className="col-lg-12 commTopButtonRightLeftPadding">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Customer Orders</h5>
                      <LoaderSmall isLoading={marketingTeamLoading} />
                      {!marketingTeamLoading ? (
                        hasChartData(marketingTeamData) ? (
                          <TreeMapChartDashboardChart
                            chartdata={marketingTeamData}
                          />
                        ) : (
                          <p className="text-center text-muted py-5">
                            No customer orders available
                          </p>
                        )
                      ) : null}
                    </div>
                  </div>
                </div> */}
                </div>
              )}
            </section>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default CustomerV2Dashboard;
